import React from 'react';
import { Menu as MuiMenu, MenuProps as MuiMenuProps } from '@mui/material';
import {
  FixedContentProps,
  FixedPaper,
  FixedPaperContext,
} from 'src/components/Menu/FixedMenuContent';

/**
 * Props that we do not want to include with Menu.
 *
 * Using `keyof Pick` provides type safety that ensures we are
 * only blocking props that are part of the interface.
 **/
type MenuBlockedProps = keyof Pick<MuiMenuProps, 'elevation'>;

export type MenuProps = Omit<MuiMenuProps, MenuBlockedProps> &
  FixedContentProps;

export const Menu = React.forwardRef<HTMLDivElement, MenuProps>(
  function UnifyMenu({ fixedHeader, fixedFooter, slots, ...props }, ref) {
    const hasFixedContent = fixedHeader != null || fixedFooter != null;

    return (
      <FixedPaperContext.Provider
        value={{ fixedHeader, fixedFooter, popoverPaper: true }}
      >
        <MuiMenu
          {...props}
          ref={ref}
          slots={{
            ...(hasFixedContent && { paper: FixedPaper }),
            ...slots,
          }}
        />
      </FixedPaperContext.Provider>
    );
  }
);
